// import React, { useState } from "react";
// import {
//   Button,
//   TextField,
//   MenuItem,
//   Box,
//   Typography,
//   CircularProgress,
//   Snackbar,
//   Alert
// } from "@mui/material";

// const stores = [
//   { label: "SofaBed", domain: "onlinesalesonly.myshopify.com" },
//   { label: "Jennihome", domain: "jennifurniture.myshopify.com" },
//   { label: "JenniferFurniture", domain: "jennifer-convertibles.myshopify.com" },
//   { label: "Klaussner", domain: "gio-italia-home.myshopify.com" },
//   { label: "ComfortFurniture", domain: "jennifercomfortfurniture.myshopify.com" }
// ];

// // domain -> display name
// const storeNameMap = Object.fromEntries(stores.map(s => [s.domain, s.label]));

// function App() {
//   const [sourceStore, setSourceStore] = useState("");
//   const [destStore, setDestStore] = useState("");
//   const [productId, setProductId] = useState("");
//   const [response, setResponse] = useState("");
//   const [loading, setLoading] = useState(false);

//   // Snackbar state
//   const [snackOpen, setSnackOpen] = useState(false);
//   const [snackMsg, setSnackMsg] = useState("");
//   const [snackSeverity, setSnackSeverity] = useState("success"); // 'success' | 'error' | 'info' | 'warning'

//   const handleCloseSnack = (event, reason) => {
//     if (reason === "clickaway") return;
//     setSnackOpen(false);
//   };

//   const handleDuplicate = async () => {
//     setLoading(true);
//     setResponse("");
//     setSnackOpen(false);

//     try {
//       const res = await fetch(process.env.REACT_APP_API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           product_id: productId,
//           source_store: sourceStore,
//           destination_store: destStore
//         })
//       });

//       const raw = await res.text();
//       let data;
//       try {
//         data = JSON.parse(raw);
//       } catch {
//         // If not JSON, show raw
//         setResponse("Unexpected Response: " + raw);
//         setSnackMsg("Unexpected response from server");
//         setSnackSeverity("error");
//         setSnackOpen(true);
//         setLoading(false);
//         return;
//       }

//       if (res.ok && data.message === "Success" && data.new_product_id) {
//         const sourceName = storeNameMap[sourceStore] || sourceStore;
//         const destName = storeNameMap[destStore] || destStore;

//         const pretty = `Product ${data.source_product_id} copied from ${sourceName} to ${destName} as new product ${data.new_product_id}`;
//         setResponse(pretty);
//         setSnackMsg("Product copied successfully");
//         setSnackSeverity("success");
//         setSnackOpen(true);
//       } else {
//         // show error or raw JSON
//         const errText = data.error || data.message || JSON.stringify(data);
//         setResponse(JSON.stringify(data, null, 2));
//         setSnackMsg(errText || "Operation failed");
//         setSnackSeverity("error");
//         setSnackOpen(true);
//       }
//     } catch (err) {
//       setResponse("Error: " + err.message);
//       setSnackMsg("Network or unexpected error: " + err.message);
//       setSnackSeverity("error");
//       setSnackOpen(true);
//     }

//     setLoading(false);
//   };

//   return (
//     <Box
//       p={4}
//       width="520px"
//       margin="40px auto"
//       borderRadius="10px"
//       boxShadow="0px 6px 20px rgba(0,0,0,0.08)"
//     >
//       <Typography variant="h5" mb={2} textAlign="center">
//         Tendrils — Duplicate Shopify Product
//       </Typography>

//       <TextField
//         select
//         fullWidth
//         label="Source Store"
//         value={sourceStore}
//         onChange={(e) => setSourceStore(e.target.value)}
//         margin="normal"
//       >
//         {stores.map((s) => (
//           <MenuItem key={s.domain} value={s.domain}>
//             {s.label}
//           </MenuItem>
//         ))}
//       </TextField>

//       <TextField
//         select
//         fullWidth
//         label="Destination Store"
//         value={destStore}
//         onChange={(e) => setDestStore(e.target.value)}
//         margin="normal"
//       >
//         {stores.map((s) => (
//           <MenuItem key={s.domain} value={s.domain}>
//             {s.label}
//           </MenuItem>
//         ))}
//       </TextField>

//       <TextField
//         fullWidth
//         label="Product ID"
//         value={productId}
//         onChange={(e) => setProductId(e.target.value)}
//         margin="normal"
//       />

//       <Button
//         variant="contained"
//         fullWidth
//         sx={{ mt: 2, py: 1 }}
//         onClick={handleDuplicate}
//         disabled={!sourceStore || !destStore || !productId || loading}
//       >
//         {loading ? (
//           <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
//             <CircularProgress size={18} thickness={5} />
//             Duplicating...
//           </span>
//         ) : (
//           "Duplicate Product"
//         )}
//       </Button>

//       {response && (
//         <Box
//           mt={3}
//           p={2}
//           bgcolor="#e9f8ff"
//           borderRadius="8px"
//           sx={{ whiteSpace: "pre-wrap", fontSize: "16px" }}
//         >
//           {response}
//         </Box>
//       )}

//       <Snackbar
//         open={snackOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnack}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert onClose={handleCloseSnack} severity={snackSeverity} sx={{ width: "100%" }}>
//           {snackMsg}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// export default App;

import React, { useState } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Box,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
  IconButton
} from "@mui/material";

import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const stores = [
  { label: "SofaBed", domain: "onlinesalesonly.myshopify.com" },
  { label: "Jennihome", domain: "jennifurniture.myshopify.com" },
  { label: "JenniferFurniture", domain: "jennifer-convertibles.myshopify.com" },
  { label: "Klaussner", domain: "gio-italia-home.myshopify.com" },
  { label: "ComfortFurniture", domain: "jennifercomfortfurniture.myshopify.com" }
];

// mapping domain -> cleaner label
const storeNameMap = Object.fromEntries(stores.map(s => [s.domain, s.label]));

export default function App() {
  const [sourceStore, setSourceStore] = useState("");
  const [destStore, setDestStore] = useState("");
  const [productId, setProductId] = useState("");

  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState("");

  // Snackbar
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("success");

  // Theme
  const [dark, setDark] = useState(true);

  const handleCloseSnack = () => setSnackOpen(false);

  const swapStores = () => {
    setSourceStore(destStore);
    setDestStore(sourceStore);
  };

  const handleDuplicate = async () => {
    if (!sourceStore || !destStore || !productId) return;

    setLoading(true);
    setResponse("");

    try {
      const res = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          source_store: sourceStore,
          destination_store: destStore,
          product_id: productId
        })
      });

      const raw = await res.text();
      let data;
      try {
        data = JSON.parse(raw);
      } catch {
        setResponse("Unexpected Response: " + raw);
        setSnackOpen(true);
        setSnackMsg("Unexpected response from server");
        setSnackSeverity("error");
        return;
      }

      if (res.ok && data.message === "Success") {
        const prettyMsg = `Product ${data.source_product_id} copied from ${storeNameMap[sourceStore]} to ${storeNameMap[destStore]} as new product ${data.new_product_id}`;
        setResponse(prettyMsg);

        setSnackMsg("Product duplicated successfully");
        setSnackSeverity("success");
        setSnackOpen(true);
      } else {
        setResponse(JSON.stringify(data, null, 2));
        setSnackMsg("Failed: " + (data.message || "Error"));
        setSnackSeverity("error");
        setSnackOpen(true);
      }
    } catch (err) {
      setResponse("Error: " + err.message);
      setSnackMsg(err.message);
      setSnackSeverity("error");
      setSnackOpen(true);
    }

    setLoading(false);
  };

  // Styling for TextFields (dark/light)
  const textFieldSx = {
    "& .MuiOutlinedInput-root": {
      color: dark ? "#fff" : "#000",
      background: dark ? "rgba(255,255,255,0.05)" : "#fff",
      borderRadius: "8px",

      "& fieldset": {
        borderColor: dark ? "#555" : "#bbb"
      },
      "&:hover fieldset": {
        borderColor: dark ? "#888" : "#222"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#6ea0ff"
      }
    },

    "& .MuiInputLabel-root": {
      color: dark ? "#bbb" : "#444"
    },

    "& .MuiSvgIcon-root": {
      color: dark ? "#ddd" : "#333"
    },

    "& input::placeholder": {
      color: dark ? "#999" : "#666"
    }
  };

  return (
    <Box
      height="100vh"
      width="100vw"
      sx={{
        background: dark ? "#0d0d0d" : "#f5f7fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "0.4s ease"
      }}
    >
      {/* CARD */}
      <Box
        p={4}
        width="500px"
        borderRadius="16px"
        sx={{
          background: dark
            ? "rgba(255,255,255,0.05)"
            : "rgba(255,255,255,0.9)",
          boxShadow: dark
            ? "0 0 40px rgba(0,0,0,0.6)"
            : "0 4px 20px rgba(0,0,0,0.12)",
          backdropFilter: "blur(10px)",
          transition: "0.4s ease"
        }}
      >
        {/* HEADER */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="h5"
            sx={{
              color: dark ? "#fff" : "#111",
              fontWeight: 700
            }}
          >
            Tendrils — Duplicate Shopify Product
          </Typography>

          <IconButton onClick={() => setDark(!dark)}>
            {dark ? (
              <LightModeIcon sx={{ color: "#ffd369" }} />
            ) : (
              <DarkModeIcon sx={{ color: "#222" }} />
            )}
          </IconButton>
        </Box>

        {/* FORM */}
        <Box mt={3}>
          <Box display="flex" gap={2} alignItems="center">
            {/* Source */}
            <TextField
              select
              fullWidth
              label="Source Store"
              value={sourceStore}
              onChange={(e) => setSourceStore(e.target.value)}
              sx={textFieldSx}
            >
              {stores.map((s) => (
                <MenuItem key={s.domain} value={s.domain}>
                  {s.label}
                </MenuItem>
              ))}
            </TextField>

            {/* Swap Button */}
            <IconButton
              onClick={swapStores}
              sx={{
                transform: "rotate(90deg)",
                transition: "0.2s",
                "&:hover": { transform: "rotate(450deg)" }
              }}
            >
              <SwapHorizIcon sx={{ color: dark ? "#fff" : "#222" }} />
            </IconButton>

            {/* Destination */}
            <TextField
              select
              fullWidth
              label="Destination Store"
              value={destStore}
              onChange={(e) => setDestStore(e.target.value)}
              sx={textFieldSx}
            >
              {stores.map((s) => (
                <MenuItem key={s.domain} value={s.domain}>
                  {s.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* PRODUCT ID */}
          <TextField
            fullWidth
            label="Product ID"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            margin="normal"
            sx={textFieldSx}
          />

          {/* Duplicate Button */}
          <Button
            variant="contained"
            fullWidth
            sx={{
              mt: 2,
              py: 1.3,
              borderRadius: "10px",
              fontWeight: 700,
              background: "linear-gradient(90deg,#6ea0ff,#8bb3ff)",
              color: "#fff",
              boxShadow: "0 4px 12px rgba(110,160,255,0.3)",
              "&:hover": {
                background: "linear-gradient(90deg,#7aa8ff,#98bdff)"
              }
            }}
            onClick={handleDuplicate}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={22} sx={{ color: "#fff" }} />
            ) : (
              "DUPLICATE PRODUCT"
            )}
          </Button>

          {/* SUCCESS/ERROR RESULT */}
          {response && (
            <Box
              mt={3}
              p={2}
              borderRadius="10px"
              sx={{
                background: dark ? "#111" : "#eef6ff",
                color: dark ? "#fff" : "#000",
                fontSize: "15px"
              }}
            >
              {response}
            </Box>
          )}
        </Box>

        {/* Open in Admin Button */}
        {response.includes("new product") && (
          <Button
            fullWidth
            sx={{
              mt: 2,
              fontWeight: 600,
              background: dark ? "#1b1b1b" : "#e3e9f5",
              color: dark ? "#4ea1ff" : "#244a8f",
              "&:hover": {
                background: dark ? "#272727" : "#dce3f0"
              }
            }}
            onClick={() => {
              const newId = response.split("new product ")[1];
              window.open(
                `https://${destStore}/admin/products/${newId}`,
                "_blank"
              );
            }}
          >
            OPEN IN ADMIN
          </Button>
        )}
      </Box>

      {/* Snackbar Notifications */}
      <Snackbar
        open={snackOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackSeverity}
          sx={{ width: "100%" }}
          onClose={handleCloseSnack}
        >
          {snackMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
}
